var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcecream = function SvgIcecream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 11 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2000_46685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.888 3.51q.014-.13.014-.26A2.34 2.34 0 0 0 5.564.916 2.337 2.337 0 0 0 3.245 3.51c-.312.201-.495.54-.495.912 0 .44.275.843.683 1.008l1.705 4.776.018.032a.44.44 0 0 0 .825 0h.01L7.15 6.994a.99.99 0 0 0 .665-.935v-.674c.357-.188.577-.554.577-.958 0-.37-.183-.71-.495-.912zM5.83 5.51v.55a.98.98 0 0 0 .646.926l-.907 2.53-1.435-4.006zm.252-.633H3.836a.455.455 0 0 1-.183-.87h1.146a.317.317 0 0 0 0-.633h-.93a1.68 1.68 0 0 1 .44-1.27c.32-.352.783-.559 1.26-.559a1.708 1.708 0 0 1 1.664 2.077l-.065.28.27.09c.189.06.312.235.312.432a.46.46 0 0 1-.339.44l-.238.06v1.136a.358.358 0 0 1-.715 0v-.802c0-.21-.17-.376-.376-.376z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2000_46685"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75.917h5.633v9.602H2.75z"
  })))));
};
export default SvgIcecream;